import { Add } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Input,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import React, { useRef, useState } from "react";
import { useDispatch, connect } from "react-redux";
import { createPlayList } from "../../store/actions/playList";

function PlaylistCreateDialog({ open, setOpen, loading }) {
  const playlistInputRef = useRef(null);
  const dispatch = useDispatch();
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>create playlist </DialogTitle>
      <DialogContent>
        <Grid container alignItems="center">
          <Grid>
            <Input
              inputRef={playlistInputRef}
              type="text"
              sx={{ pr: 2, width: "50%" }}
            />
          </Grid>
          <Grid>
            {" "}
            <LoadingButton
              loading={loading ? loading.loading : false}
              onClick={() => {
                dispatch(createPlayList(playlistInputRef.current.value));
              }}
              variant="contained"
              color="success"
              startIcon={<Add />}
              sx={{ pl: 2 }}>
              Add
            </LoadingButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.loading["playlist/create"],
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setLoading: () => {
      dispatch("LOADING");
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlaylistCreateDialog);
